import React, { useEffect } from "react";

const RELOAD_KEY = "gutenstack-chunk-reload";

function isChunkLoadError(error) {
  const message = `${error?.name || ""} ${error?.message || ""}`;
  return /Loading chunk|ChunkLoadError|Unexpected token '<'|dynamically imported module|Importing a module script failed|Failed to fetch dynamically imported module/i.test(message);
}

function alreadyReloaded() {
  try {
    return sessionStorage.getItem(RELOAD_KEY) === "1";
  } catch {
    return false;
  }
}

export function ClearChunkReloadFlag() {
  useEffect(() => {
    try {
      sessionStorage.removeItem(RELOAD_KEY);
    } catch {
      // sessionStorage can be unavailable
    }
  }, []);
  return null;
}

class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    if (!isChunkLoadError(error) || alreadyReloaded()) return;
    try {
      sessionStorage.setItem(RELOAD_KEY, "1");
      window.location.reload();
    } catch {
      // If storage or reload fails, render() shows the error state.
    }
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    if (isChunkLoadError(error)) {
      if (!alreadyReloaded()) return null;
      return (
        <div className="app-error" role="alert">
          <p>This page is out of date. Reload to get the latest version.</p>
          <button type="button" onClick={() => window.location.reload()}>
            Reload
          </button>
        </div>
      );
    }

    return (
      <div className="app-error" role="alert">
        <p>Something went wrong loading this page.</p>
        <button type="button" onClick={() => this.setState({ error: null })}>
          Try again
        </button>
      </div>
    );
  }
}

export default ChunkErrorBoundary;
